import React, { useEffect, useState } from 'react'
//import { FiAlertTriangle } from 'react-icons/fi';
//import { FaEdit } from "react-icons/fa";
//import { FaExclamationCircle } from "react-icons/fa";
//import { FaCheckCircle } from "react-icons/fa";

// import { RiSave3Fill } from "react-icons/ri";
import { TbPencilQuestion } from "react-icons/tb";
import { CiEdit } from "react-icons/ci";
import { FaSave } from "react-icons/fa";
import { GiCheckMark } from "react-icons/gi";
import { EDIT_ERROR, EDIT_FIXED, OK, REQUIRED_ERROR, SAVE_ERROR, SAVE_FIXED } from './Cell';
import './CellControl.css';

export default function CellControl({feedbackStatus}) {
  const [showCheck, setShowCheck]  =  useState(false);
  const [icon, setIcon] = useState();
  
  const RequiredIcon = TbPencilQuestion; // FaExclamationCircle;
  const EditIcon = CiEdit;
  const SaveIcon = FaSave; //RiSave3Fill;


  useEffect(()=>{
    if (feedbackStatus) {
      //console.log('[CellControl Effect] [feedbackStatus: %s]', feedbackStatus);
      
      const getIcon = () => {
        switch (feedbackStatus) {
          case SAVE_ERROR: return <SaveIcon color='#df4719'/>;
          case REQUIRED_ERROR: return <RequiredIcon color='yellow'/>;
          //TODO: case IS_REQUIRED_FIXED -->  show nothing...
          case EDIT_ERROR: return <EditIcon color='#ef4719' fontWeight='bold'/>;
          // case EDIT_FIXED: return <EditIcon color='green' />;
          // case SAVE_FIXED: return <SaveIcon color='green' />;
          
          case OK: 
          default: return '';
        }
      };
      
      setIcon(getIcon());
      
      if (feedbackStatus === EDIT_FIXED || feedbackStatus === SAVE_FIXED) {
        setShowCheck(true);
        setTimeout(()=> {
          setShowCheck(false);
        }, 800);
      }
    }
  }, [feedbackStatus]);

  //  const saveIcon = isSaveOk ? '' : <RiSave3Fill />;
  //  const editIcon = isEditOk ? '' : <FiAlertTriangle />;
  //  const editStyle = isEditOk ? 'kCellInputOk': 'kCellInputError';
  //  const saveStyle = isSaveOk ? 'kCellSaveOk' : 'kCellSaveError';
//  const CheckIcon = GiCheckMark;

  // const ctrlColor = isModified ? isEditOk ? 'darkgreen' : 'darkred' : 'transparent';    
  // const ctrlStyle = `kCellControl ${ctrlColor}`;
  //const icon = isSaveOk ? '' : <RiSave3Fill color='orange'/>;


  return (
    <div className='kCellControl'>
      {showCheck && <GiCheckMark color='green'/>}
      {!showCheck && icon}
    </div>
  )
}
